import { render, staticRenderFns } from "./CrearAlertasBaseModal.vue?vue&type=template&id=0aad6fda&"
import script from "./CrearAlertasBaseModal.vue?vue&type=script&lang=ts&"
export * from "./CrearAlertasBaseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0aad6fda', component.options)
    } else {
      api.reload('0aad6fda', component.options)
    }
    module.hot.accept("./CrearAlertasBaseModal.vue?vue&type=template&id=0aad6fda&", function () {
      api.rerender('0aad6fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfigurarBase/CrearAlertasBaseModal.vue"
export default component.exports